/**
 * Determines if an error response should be shown to the user
 * Suppresses errors for 401 (Unauthorized) since user is logged out
 *
 * @param {Object} response - API response object
 * @returns {boolean} - True if error should be displayed
 */
export const shouldShowError = (response) => {
    // Don't show errors for successful responses
    if (response.success) {
        return false;
    }

    // Don't show errors for 401 (unauthorized) - user is logged out
    if (response.status === 401) {
        return false;
    }

    // Show all other errors
    return true;
};
